export default __webpack_public_path__ + "static/media/x.6586ad0b.svg";